import dynamic from 'next/dynamic';
import { useState } from 'react';

import useLocalStorageState from 'hooks/useLocalStorageState';
import useMediaQuery from 'hooks/useMediaQuery';
import useScrollPosition from 'hooks/useScrollPosition';

import { useUser } from 'providers/UserProvider';

import LOCAL_STORAGE from 'constants/localStorage';

const DynamicDownloadAppCTA = dynamic(() => import('./DownloadAppCTA'), {
  ssr: false,
});

const DownloadAppCTA = ({ initialOpenState = false }) => {
  const { isLoggedIn } = useUser();
  const [isOpen, setOpen] = useState(initialOpenState);
  const { isMd } = useMediaQuery();
  const [isDownloadAppCtaActive, setDownloadAppCtaActive] =
    useLocalStorageState(
      LOCAL_STORAGE.IS_DOWNLOAD_APP_CTA_COMPONENT_HOME_AB_TEST_ACTIVE,
      true
    );
  const [isLGPDAlertEnabled] = useLocalStorageState(
    LOCAL_STORAGE.IS_SHOWING_LGPD_ALERT,
    true
  );

  useScrollPosition(
    () => {
      if (!isLGPDAlertEnabled && !isOpen && !isMd && isDownloadAppCtaActive) {
        setOpen(true);
      }
    },
    { deps: [isLGPDAlertEnabled, isDownloadAppCtaActive, isOpen] }
  );

  const onClose = () => {
    setOpen(false);
    setDownloadAppCtaActive(false);
  };

  if (!isOpen || isLoggedIn) {
    return null;
  }

  return <DynamicDownloadAppCTA onClick={onClose} onClose={onClose} />;
};

export default DownloadAppCTA;
